const themeColors = {
  primary: {
    DEFAULT: '#C8102E', // MAS Red
    low: 'rgba(200, 16, 46, 0.1)',
    glow: 'rgba(200, 16, 46, 0.4)',
    hover: '#A60D26',
  },
  secondary: {
    DEFAULT: '#000000', // MAS Black
    paper: '#121214',   // Surface
  },
  background: {
    DEFAULT: '#0A0A0B', // Dark 900
    alt: '#1A1A1C',     // Dark 700
  },
  text: {
    primary: '#FFFFFF',
    secondary: '#D1D1D1',
    dim: '#888888',
  },
  status: {
    success: '#22C55E',
    warning: '#F59E0B',
    error: '#C8102E',
    info: '#3B82F6',
  }
};

export default themeColors;
